import { render } from "./edit-client-service.vue?vue&type=template&id=ffbc5862"
import script from "./edit-client-service.vue?vue&type=script&lang=js"
export * from "./edit-client-service.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__